import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const AssetsTable = ({
  children,
  count,
  company,
  subcompany,
  permissions,
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  // children.filter(child => child.props.asset.createdAt = child.props.asset.createdAt.split('T')[0])

  // console.log("prueba",children)
  const headers = [
    // { variable: "id", text: t("assets.fields.id") + ": ", type: "h3" }, // Pendiente
    { variable: 'number', text: t('assets.fields.number') + ': ', type: 'h3' },
    { variable: 'name', text: t('assets.fields.name') + ': ' },
    { variable: 'createdAt', text: t('assets.fields.createdAt') + ': ', format: 'formatTimeStamp' },
    {
      parent: '_account',
      variable: 'name',
      text: t('assets.fields.account'),
    },
    {
      parent: '_subaccount',
      variable: 'name',
      text: t('assets.fields.subaccount'),
    },
    {
      parent: '_costCenter',
      variable: 'name',
      text: t('assets.fields.costCenter'),
    },
    // { variable: "location", text: t("assets.fields.location") + ": " },
    {
      parent: '_employee',
      variable: 'name',
      text: t('assets.fields.employee'),
    },
    {
      variable: 'validatedText',
      text: t('assets.fields.validated'),
    },
    {
      parent: '_status',
      variable: 'value',
      // text: t("catalog.status.elements.not_depreciating"),
      // text: t("catalog.status.elements.not_depreciating"),
      text: t('assets.fields.status'),
    },
    {
      variable: 'disabled',
      text: t('assets.fields.disabled') + ': ',
      boolean: true,
    },
    {
      variable: 'hasPendingChanges',
      text: t('assets.fields.hasPendingChanges') + ': ',
      boolean: true,
    },
  ];
  // canRequestUpdate = { permissions["acl.assets.request_update"]}
  // canEdit = { permissions["acl.assets.update"]}
  // canEnable = { permissions["acl.assets.enable"]}
  // canDisable = { permissions["acl.assets.disable"]}

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.assets.update',
    showDetail: true,
    // togglePermission: "acl.assets.toggle",
    canRequestUpdate: 'acl.assets.request_update',
    disablePermission: 'acl.assets.disable',
    enablePermission: 'acl.assets.enable',
    editUrl: 'assets', //Url para editar empleado
    propsName: 'asset', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    t: t,
  };

  // console.log(dataCard);

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          {/* <th>
          <Common.Checkbox
            className="icheckbox_flat-green"
            value={"all"}
            onChange={() => {}}
          />
        </th> */}
          {/* <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="indexInteger.number"
            handleOrderChange={handleOrderChange}
          >
            {t("assets.fields.consecutive")}
          </Common.ThSortable> */}
          {/* <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_prefix.value"
            handleOrderChange={handleOrderChange}
          >
            {t("assets.fields.prefix")}
          </Common.ThSortable> */}
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="number"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.number')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.createdAt')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_account.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.account')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_subaccount.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.subaccount')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_costCenter.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.costCenter')}
          </Common.ThSortable>

          <th>{t('assets.fields.location')}</th>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_employee.name"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.employee')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="validated"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.validated')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_status.value"
            handleOrderChange={handleOrderChange}
          >
            {t('assets.fields.status')}
          </Common.ThSortable>
          {/* 
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="_provider.name"
            handleOrderChange={handleOrderChange}
          >
            {t("assets.fields.provider")}
          </Common.ThSortable> */}
          {/* <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="buyOrder"
            handleOrderChange={handleOrderChange}
          >
            {t("assets.fields.buyOrder")}
          </Common.ThSortable> */}

          <th>{t('assets.fields.disabled')}</th>
          <th>{t('assets.fields.hasPendingChanges')}</th>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={12} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(AssetsTable);



// WEBPACK FOOTER //
// src/components/assets/AssetsTable.js